import React from 'react';
import { FormattedMessage } from 'react-intl';
import { history } from './../../configuration/store';

class MessagesPage extends React.Component {
    render() {
        return (
            <div className="page">
                <div className="row">
                    <div className="col-xs-12">
                        <h4>{MessagesPage.meta.label}</h4>
                    </div>
                    <div className="col-xs-12">
                        <span>messages go here ...</span>
                    </div>
                </div>
            </div>
        );
    }
}

MessagesPage.meta = {
    label: <FormattedMessage id={'messages'} defaultMessage={'Messages'} />,
    icon: 'chat_bubble_outline',
    action: () => history.push('/messages'),
    locations: ['/messages']
};

export default MessagesPage;



// WEBPACK FOOTER //
// ./src/pages/messages/index.jsx